<template>
  <v-app>
    <v-system-bar
      app
      height="35"
      color="white">
      <v-spacer></v-spacer>
      <Language/>
    </v-system-bar>
    <v-app-bar
      app
      height="80"
      color="white">
      <div class="appbarbox">
        <div class="box1 light-blue darken-3">
          <div class="logobox">
            <v-img
              @click="$router.push('/')"
              alt="Logo"
              contain
              src="http://47.94.10.11/static/files/logovue.gif"
              transition="scale-transition"
              width="350"/>
          </div>
          <Menubar @navhover="navhover" @naventer="naventer"/>
        </div>
        <v-hover v-model="subhover">
          <v-expand-x-transition>
            <div
              class="box2"
              v-if="hoverlist.includes(true) || subhover">
            <Navtab  :navitem = "category_enter" />
            </div>
          </v-expand-x-transition>
        </v-hover>
      </div>
    </v-app-bar>
    <v-main>
      <v-container>
        <router-view/>
      </v-container>
    </v-main>
      <v-footer
        color="grey darken-4"
        class="d-flex flex-column justify-center white--text"
        padless>
      <div class="w-100 d-flex">
        <div>
          <v-btn v-if="$store.state.lang == 'cn'" small tile>友情链接:</v-btn>
          <v-btn v-else small tile>Friendly link:</v-btn>
        </div>
        <div v-for="i in linklist" :key="i.id" style="border-left:1px solid #fff;">
          <v-btn small text dark :href="i.href">{{i[$store.state.lang+'_title']}}</v-btn>
        </div>
      </div>
      <div class="text-center">
        <div class="text-caption grey--text text--lighten-1">危险化学品经营许可证：大旅安经字[2018]0064 | 辽ICP备14014802号 | 辽公网安备：21021202000258</div>
        <div class="text-caption grey--text text--lighten-1"> Copyright@大连盛隆·{{ new Date().getFullYear() }}</div>
      </div>
      <Snackbar :isactive="snack_isactive" :text="snack_text"></Snackbar>
    </v-footer>
  </v-app>
</template>

<script>
import Menubar from '@/components/Menubar.vue'
import Navtab from '@/components/Navtab.vue'
import Language from '@/components/Language.vue'
import Snackbar from '@/components/Snackbar.vue'
export default {
  name: 'App',
  components: {
    Menubar,
    Language,
    Navtab,
    Snackbar,
  },
  data(){
      return {
      subhover:false,
      hoverlist:[],
      category_enter:{},
      linklist_io_api:'linklist/io/',
      linklist:[],
      snack_isactive:false,
      snack_text:'',
    }
  },
  methods:{
    navhover(v){
    this.hoverlist = v;
    },
    naventer(v){
    this.category_enter = v;
    },
    fetch(){
      let postdata = {};
      this.$axios.post(this.$store.state.baseurl + this.linklist_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.linklist = response.data.data;
              }
            }
          )
          .catch(
            function (e){
              this.snack_text='努力加载中...';
              this.snack_isactive =true;
            }
          )
    },
  },
  mounted(){
    this.fetch();
  },
}
</script>
<style scoped>
.logobox{
  border:1px solid #ccc;
  background:#ccc;
  margin-left:15px;
}
.appbarbox{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.box1{
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box2{
  width: 90%;
  padding-top: 12px;
  display: flex;
  justify-content: center;
}
</style>
